<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-6 col-md-6">
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
      </div>
      <!-- <div class="col-lg-6 col-md-6 mg-a" style="text-align: right;" >
      <span class="slctDteLbl">Select Date:</span>
      <nz-date-picker [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat" [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)" class="dte_picker"></nz-date-picker>


    </div> -->
    </div>
  </div>
</div>

<div class="apsfl_dshbrd">
  <!-- <button (click)="open()"></button> -->

  <app-oms-dashbourd-cards
    [slctd_dstrt]="slctd_dstrt"
    (slctdata)="selctedCatrd($event)"
  ></app-oms-dashbourd-cards>

  <div class="row">
    <div class="col-lg-12 col-md-12">
      <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
        <div class="row" style="margin-top: -10px; margin-bottom: 5px">
          <div class="col-md-8">
            @if (selctedcrd?.crd_hdr == 'WORKS') {
            <div class="card_hdr_ttl" style="position: relative">
              Activities
            </div>
            } @if (selctedcrd?.crd_hdr == 'TRIPS') {
            <div class="card_hdr_ttl" style="position: relative">
              Travel Registry
            </div>
            } @if (selctedcrd?.crd_hdr == 'EXPENSES') {
            <div class="card_hdr_ttl" style="position: relative">Expenses</div>
            }
          </div>

          <div class="col-md-4" style="text-align: right">
            <!-- <div class="col-md-3" style="text-align: left;"> -->
            @for (v of viewsdata; track v) {
            <div
              class="vws_data"
              (click)="slectdvw(v.vw_id)"
              [ngClass]="v.vw_id == slctdvw ? 'slct_vw' : 'dflt_vw'"
            >
              <span nz-icon [nzType]="v.vw_icn" nzTheme="outline"></span>
            </div>
            }
          </div>
        </div>
        <div class="card_ttl">
          <div class="row">
            <div class="col-md-10">
              <div class="row pstnCls">
                @if (tb_id != '3') {
                <div class="col-md-12" style="text-align: left; padding: 0px">
                  @for (t of tabsdata; track t) {
                  <div
                    class="tabs_data"
                    (click)="ChangeLevel(t.tab_id)"
                    [ngClass]="t.tab_id == lvl_id ? 'slct_tab' : 'dflt_tab'"
                  >
                    {{ t.tab_nm }}
                  </div>
                  } @if (lvl_id!=3) {
                  <nz-range-picker
                    [(ngModel)]="dateRnge"
                    (ngModelChange)="onChangeDate($event)"
                    [nzFormat]="'dd-MM-yyyy'"
                    style="height: 37px; border-radius: 4px"
                  ></nz-range-picker>
                  }
                </div>
                } @if (tb_id == '3') {
                <div class="col-md-12" style="text-align: left; padding: 0px">
                  @for (t of tabsdata1; track t) {
                  <div
                    class="tabs_data"
                    (click)="ChangeLevel(t.tab_id)"
                    [ngClass]="t.tab_id == lvl_id ? 'slct_tab' : 'dflt_tab'"
                  >
                    {{ t.tab_nm }}
                  </div>
                  } @if (lvl_id!=3) {
                  <nz-range-picker
                    [(ngModel)]="dateRnge"
                    (ngModelChange)="onChangeDate($event)"
                    [nzFormat]="'dd-MM-yyyy'"
                    style="height: 37px; border-radius: 4px"
                  ></nz-range-picker>
                  }
                </div>
                }
              </div>
            </div>
            <div class="col-md-2"></div>
          </div>
        </div>
        @if (slctdvw==1) {
        <div
          class="col-lg-12 col-md-12 mgnb-2 p-8 apsflgrid_sumry"
          style="padding: 0px"
        >
          <app-data-grid
            [totalItems]="gridTotals0"
            [groupItems]="gridGroups0"
            id="gridContainer"
            class="p-8"
            style="width: 100%"
            [dataSource]="gridData"
            [legacyColumns]="columnDefs"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="true"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="OMS Dashboard"
            [pageSize]="26"
            [allowedPageSizes]="[5, 10, 25, 50]"
            [showPageSizeSelector]="true"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            (cellClick)="onCellClick($event)"
            [cellPrepared]="bound_onCellPrepared"
          >
            <!-- -->
            <!-- -->
            <!-- -->
          </app-data-grid>
        </div>
        } @if (slctdvw==2 && (tb_id=='1' || tb_id=='2' || ( tb_id=='3' &&
        lvl_id!=2))) {
        <div class="col-md-12 p-8">
          <div class="crd_style">
            <div class="apxgrphone">
              <div id="chart1">
                <app-chart [options]="chartOptionsFour"></app-chart>
              </div>
            </div>
          </div>
        </div>
        } @if (slctdvw==2 && (tb_id=='3' && lvl_id==2)) {
        <div class="col-lg-12 col-md-12">
          <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 30px">
            <div class="row">
              <div class="col-lg-9 col-md-9"></div>
              <div class="col-lg-2 col-md-2">
                <span>Expense Category</span>
                <nz-select
                  class="slctBx"
                  nzShowSearch
                  [(ngModel)]="selectdCtgry"
                  (ngModelChange)="onCtgrySlct($event)"
                  nzPlaceHolder="Expense Category"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (t of expenseCtgry; track t) {
                  <nz-option
                    [nzValue]="t.expne_ctgry_id"
                    [nzLabel]="t.expne_ctgry_nm"
                  ></nz-option>
                  }
                </nz-select>
              </div>
              <div class="col-lg-1 col-md-1"></div>
            </div>
            @if (expnsGrapData && expnsGrapData.length>0) {
            <div class="col-lg-12 col-md-12 mgnb-2 p-8">
              <div id="multichart">
                <app-chart [options]="multiChartOptions"></app-chart>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>

    <div class="col-lg-12 col-md-12">
      <div class="crd_style">
        <div class="card_ttl">
          <div class="row">
            <div class="col-md-10">
              <div class="row pstnCls" style="position: relative">
                <div class="col-md-12">
                  <div
                    class="card_hdr_ttl"
                    style="position: relative; left: 0px"
                  >
                    Activities
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div
                class="row"
                style="
                  padding: 10px;
                  margin-bottom: 0px;
                  background: linear-gradient(45deg, #fff4e7, #ffeded);
                  border-radius: 10px 10px 0px 0px;
                "
              >
                <div class="col-lg-2 col-md-2">
                  <div class="fltrLbls">District</div>
                  <nz-select
                    nzShowSearch
                    class="slctBx"
                    [(ngModel)]="tnt_id"
                    (ngModelChange)="ontntSelect($event)"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                    @for (t of tntLst; track t) {
                    <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm">
                    </nz-option>
                    }
                  </nz-select>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="fltrLbls">Work Group</div>
                  <nz-select
                    nzShowSearch
                    class="slctBx"
                    [(ngModel)]="wrk_grp_id"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                    @for (t of wrkGrpLst; track t) {
                    <nz-option
                      [nzValue]="t.wrk_grp_id"
                      [nzLabel]="t.wrk_grp_nm"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="fltrLbls">Work Status</div>
                  <nz-select
                    nzShowSearch
                    class="slctBx"
                    [(ngModel)]="oms_wrk_sts_id"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                    @for (t of wrkStsLst; track t) {
                    <nz-option
                      [nzValue]="t.oms_wrk_sts_id"
                      [nzLabel]="t.wrk_sts_nm"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </div>
                <div class="col-lg-3 col-md-3">
                  <!-- <div class="fltrLbls">From</div>
                  <nz-date-picker [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat"
                    [(ngModel)]="frmDt" (ngModelChange)="onChange($event)"
                  style="    width: 100%; height: 32px; "></nz-date-picker>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="fltrLbls">To</div>
                  <nz-date-picker [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat"
                    [(ngModel)]="toDt" (ngModelChange)="onDtChange($event)"
                  style="    width: 100%; height: 32px; "></nz-date-picker> -->
                  <div class="fltrLbls">Select Date</div>
                  <nz-range-picker
                    [(ngModel)]="dateRange"
                    (ngModelChange)="onChange($event)"
                    [nzFormat]="'dd-MM-yyyy'"
                    style="height: 37px; border-radius: 4px"
                  ></nz-range-picker>
                </div>
                <div class="col-lg-2 col-md-2">
                  <button
                    (click)="getInPrgrsWrks()"
                    style="
                      margin-top: 24px;
                      background: #f15a22;
                      color: #fff;
                      border: currentColor;
                      border-radius: 4px;
                      border: 2px solid #ffb49f;
                      cursor: pointer;
                    "
                  >
                    Get Data
                  </button>
                </div>
              </div>
            </div>
            <div id="dbrdMap"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      @if (tb_id=='1') {
      <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 30px">
        <div class="row">
          <div class="col-lg-9 col-md-9"></div>
          <div class="col-lg-2 col-md-2">
            <span>Consumable Fiber Categories</span>
            <nz-select
              class="slctBx"
              nzShowSearch
              [(ngModel)]="selectdAsstCtgry"
              (ngModelChange)="onAssetCtgrySlct($event)"
              nzPlaceHolder="Expense Category"
              [ngModelOptions]="{ standalone: true }"
            >
              @for (t of AsstCtgry; track t) {
              <nz-option
                [nzValue]="t.wrk_ast_id"
                [nzLabel]="t.wrk_ast_nm"
              ></nz-option>
              }
            </nz-select>
          </div>
          <div class="col-lg-1 col-md-1"></div>
        </div>
        @if (AsstGrapData && AsstGrapData.length>0) {
        <div class="col-lg-12 col-md-12 mgnb-2 p-8">
          <div id="AsstMultichart">
            <app-chart [options]="AsstMultiChartOptions"></app-chart>
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>

<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="1500"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Work View"
  (nzOnClose)="close()"
>
  <ng-container *nzDrawerContent>
    <app-wrok-profile [wrkData]="wrkData"></app-wrok-profile>
  </ng-container>
</nz-drawer>
